export const isHidden = (el) => {
  return el && el.offsetParent === null
}
